import React from "react";
import { MdDesktopMac } from "react-icons/md";
import styled from "styled-components";
import PText from "./PText";

const ItemStyles = styled.div`
  text-align: center;
  background-color: var(--deep-dark);
  padding: 4rem;
  border-radius: 20% 60% 70% 30%/40% 20% 70% 80%;
  .servicesItem__icon {
    color: white;
    svg {
      width: 5rem;
    }
  }
  .servicesItem__title {
    font-size: 3rem;
    color: white;
    font-family: "Montserrat SemiBold";
  }
  .para {
    margin-top: 2.5rem;
  }
`;

export default function ServicesSectionItem({
  icon = <MdDesktopMac />,
  title = "Web Design",
  desc = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's ok",
}) {
  return (
    <ItemStyles className="servicesItem">
      <div className="servicesItem__icon">{icon}</div>
      <div className="servicesItem__title">{title}</div>
      <PText>{desc}</PText>
    </ItemStyles>
  );
}
